import API, { writeRefresh, writeToken } from '../constant';

/**
 * A superuser who changes their own password from Admin > Users gets a fresh
 * `{access, refresh}` pair back (the old tokens are revoked server-side).
 * Store them the way the login flow does so the session continues; returns
 * false (and touches nothing) when the response carries no tokens.
 */
export function storeRotatedSession(
  data: { access?: unknown; refresh?: unknown } | null | undefined,
  setToken: (token: string | null) => void,
): boolean {
  const access = data?.access;
  const refresh = data?.refresh;
  if (typeof access !== 'string' || !access || typeof refresh !== 'string' || !refresh) return false;
  // Same storage rules (and the same remember flag reading) as the login/refresh code.
  writeToken(access);
  writeRefresh(refresh);
  // Set the header now: the list refetch fired right after this must not use the revoked token.
  API.defaults.headers.common['Authorization'] = `Bearer ${access}`;
  setToken(access);
  return true;
}
